globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { useTranslation } from 'next-i18next';
import { Wrapper, Title, SecondaryList } from '../..';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var JobOfferBenefits = function JobOfferBenefits(_ref) {
  var jobBenefits = _ref.jobBenefits;

  var _useTranslation = useTranslation('job-position-page'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsx(Title, {
      variant: "h6-large",
      fontWeight: "semibold",
      content: t('job_offer_title'),
      textColor: "gray-900"
    }), /*#__PURE__*/_jsx(SecondaryList, {
      itemList: jobBenefits,
      orientation: "vertical",
      textColor: "gray"
    })]
  });
};
export default JobOfferBenefits;